import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import {
  API_GET_BILl_BASIC_EXCEL,
  API_GET_BILl_INDETAIL_EXCEL,
  API_GET_BILL_INFO,
} from "../../api/company.service";
import { Calendar } from "primereact/calendar";
import "./companies.css";

export const GenerateBill = ({ props }) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [billInfo, setBillInfo] = useState([]);
  const [newAccounts, setNewAccounts] = useState(0);
  const [migratedAccounts, setMigratedAccounts] = useState(0);
  const [totalConversations, setTotalConversations] = useState(0);
  const [totalMarketingMessages, setTotalMarketingMessages] = useState(0);
  const [totalUtilityMessages, setTotalUtilityMessages] = useState(0);
  const [totalServiceMessages, setTotalServiceMessages] = useState(0);
  const [totalUsers, settotalUsers] = useState(0);

  const getBillInfo = () => {
    var formattedFromDate = "";
    var formattedToDate = "";
    if (fromDate) {
      formattedFromDate =
        fromDate.getFullYear() +
        "-" +
        Number(fromDate.getMonth() + 1) +
        "-" +
        fromDate.getDate();
    }
    if (toDate) {
      formattedToDate =
        toDate.getFullYear() +
        "-" +
        Number(toDate.getMonth() + 1) +
        "-" +
        toDate.getDate();
    }

    if (formattedFromDate && formattedToDate) {
      API_GET_BILL_INFO(
        props.companies,
        formattedFromDate,
        formattedToDate
      ).then((res) => {
        setBillInfo(res);
        // var newAccs = res.reduce(
        //   (accTotal, currAcc) => accTotal + currAcc.newAccounts,
        //   0
        // );
        // var migratedAtt = res.reduce(
        //   (accTotal, currAcc) => accTotal + currAcc.migratedAccounts,
        //   0
        // );
        
        var marketingMessages = 0;
        var utilityMessages = 0;
        var serviceMessages = 0;
        var totalConv = 0;
        var totalUsers = 0;
        var newAccs = 0;
        var migratedAtt = 0;

        res.forEach(data => {
          newAccs += data.newAccounts;
          migratedAtt += data.migratedAccounts;
          marketingMessages += data.marketingMessages;
          utilityMessages += data.utilityMessages;
          serviceMessages += data.serviceMessages;
          totalConv += data.totalMessages;
          totalUsers += data.usersCount
        });

        setNewAccounts(newAccs);
        setMigratedAccounts(migratedAtt);
        setTotalMarketingMessages(marketingMessages);
        setTotalUtilityMessages(utilityMessages);
        setTotalServiceMessages(serviceMessages);
        setTotalConversations(totalConv);
        settotalUsers(totalUsers);
      });
    }
  };

  const downloadBasicInfo = () => {
    var formattedFromDate = "";
    var formattedToDate = "";
    if (fromDate) {
      formattedFromDate =
        fromDate.getFullYear() +
        "-" +
        Number(fromDate.getMonth() + 1) +
        "-" +
        fromDate.getDate();
    }
    if (toDate) {
      formattedToDate =
        toDate.getFullYear() +
        "-" +
        Number(toDate.getMonth() + 1) +
        "-" +
        toDate.getDate();
    }

    if (formattedFromDate && formattedToDate) {
      API_GET_BILl_BASIC_EXCEL(
        props.companies,
        formattedFromDate,
        formattedToDate,
        props.fileName
      ).then((res) => {});
    }
  };

  const downloadInDetailInfo = () => {
    var formattedFromDate = "";
    var formattedToDate = "";
    if (fromDate) {
      formattedFromDate =
        fromDate.getFullYear() +
        "-" +
        Number(fromDate.getMonth() + 1) +
        "-" +
        fromDate.getDate();
    }
    if (toDate) {
      formattedToDate =
        toDate.getFullYear() +
        "-" +
        Number(toDate.getMonth() + 1) +
        "-" +
        toDate.getDate();
    }

    if (formattedFromDate && formattedToDate) {
      API_GET_BILl_INDETAIL_EXCEL(
        props.companies,
        formattedFromDate,
        formattedToDate,
        props.fileName
      ).then((res) => {});
    }
  };

  return (
    <>
      <div className="card flex flex-wrap gap-3 p-fluid">
        <div className="flex-auto">
          <label htmlFor="buttondisplay" className="font-bold block mb-2">
            From
          </label>
          <Calendar
            id="buttondisplay"
            value={fromDate}
            onChange={(e) => setFromDate(e.value)}
            showIcon
            dateFormat="dd/mm/yy"
          />
        </div>
        <div className="flex-auto">
          <label htmlFor="buttondisplay" className="font-bold block mb-2">
            To
          </label>
          <Calendar
            value={toDate}
            onChange={(e) => setToDate(e.value)}
            showIcon
            dateFormat="dd/mm/yy"
          />
        </div>
        <div className="flex-auto bill-button">
          <label htmlFor="buttondisplay" className="font-bold block mb-2">
            ‎
          </label>
          <Button onClick={getBillInfo}>Generate Usage</Button>
        </div>
      </div>
      <div>
        <DataTable value={billInfo} tableStyle={{ minWidth: "50rem" }}>
          <Column field="id" header="Id"></Column>
          <Column field="name" header="Name"></Column>
          <Column field="appName" header="App Name"></Column>
          <Column field="phone" header="Phone"></Column>
          <Column
            field="marketingMessages"
            header="Marketing Messages"
          ></Column>
          <Column
            field="utilityMessages"
            header="Utility Messages"
          ></Column>
          <Column
            field="serviceMessages"
            header="Service Messages"
          ></Column>
          <Column field="totalMessages" header="Total Messages"></Column>
          <Column field="usersCount" header="Users"></Column>
          <Column field="createdAt" header="createdAt"></Column>
        </DataTable>
      </div>
      <div className="card flex flex-wrap gap-3 p-fluid">
        <div className="flex-auto">
          <h4>Total Marketing Messages : {totalMarketingMessages}</h4>
        </div>
        <div className="flex-auto">
          <h4>Total Utility Messages : {totalUtilityMessages}</h4>
        </div>
        <div className="flex-auto">
          <h4>Total Service Messages : {totalServiceMessages}</h4>
        </div>
        <div className="flex-auto">
          <h4>Total Messages : {totalConversations}</h4>
        </div>
      </div>
      <div className="card flex flex-wrap gap-3 p-fluid">
        <div className="flex-auto">
          <h4>New Accounts : {newAccounts}</h4>
        </div>
        <div className="flex-auto">
          <h4>Migrated Accounts : {migratedAccounts}</h4>
        </div>
        <div className="flex-auto">
          <h4>Total Users : {totalUsers}</h4>
        </div>
      </div>
      <div className="card flex flex-wrap gap-3 p-fluid">
        <div>
          <Button onClick={downloadBasicInfo}>Download Basic Info</Button>
        </div>
        <div>
          <Button onClick={downloadInDetailInfo}>Download Detail Info</Button>
        </div>
      </div>
    </>
  );
};
